<div class="saved-search-container">
  <div class="saved-search-header">
    <div class="saved-search-header-title">Saved Searches</div>
    <div class="saved-search-header-button" (click)="saveCurrentSearch()"><span class="fa-solid fa-floppy-disk"></span></div>
  </div>
  <div class="saved-search-item-container">

    <div class="saved-search-item" *ngFor="let query of savedQueries">
      <div class="saved-search-item-title" (click)="runSavedSearch(query.id)">{{query.name}}</div>
      <div class="saved-search-item-delete" (click)="deleteSaved(query.id)"><span class="fa-solid fa-trash-can"></span></div>
    </div>
    <div class="saved-search-item-missing" *ngIf="savedQueries.length==0">
      No saved queries found.
    </div>
  </div>
</div>


<ng-template #savesearch let-modal>
  <app-search-save-popup height="100%" style="height: 100%;"></app-search-save-popup>
</ng-template>
